var path = 'C:/programming/work/gitlab/ez-web-toolkit/src/components/timePicker/timePicker.html';
var html = "<div \r\n    uib-timepicker \r\n    ng-model=\"tp.time\" \r\n    ng-change=\"tp.changed()\" \r\n    hour-step=\"tp.hStep\" \r\n    minute-step=\"tp.mStep\" \r\n    show-meridian=\"tp.isMeridian\"\r\n    template-url=\"timepicker.html\">\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngtemplate-loader!./node_modules/html-loader!./src/components/timePicker/timePicker.html
// module id = 42
// module chunks = 0